import { Box } from '@mui/material';
import TeamShow from '@/features/teams/TeamShow';

export default function Teams() {
  return (
    <Box px={0.5}>
      <TeamShow />
    </Box>
  );
}
